import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { BsGrid } from "react-icons/bs";
import { CiGrid2H } from "react-icons/ci";
import ViewCartButton from "../ViewCartButton";
import SingleOne from "../SingleOne";
import CommonDrawer from "../drawer/CommonDrawer";
import ProductsMapList from "../ProductsMapList";
import BreadCrums from "../Breadcrums/BreadCrums";
import HeaderSection from "../HeaderSection/HeaderSection";
import Loader from "../loader/Loader";
import axios from "axios";
import { apiBaseUrl } from "../../config";
import { getList } from "../../reducer/productListSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import HeaderSlider from "../Header-Slider/HeaderSlider";
import ProductFilter from "../../components/ProductFilter/ProductFilter";
import HeaderMainNavigation from "../../layout/HeaderMainNavigation";

const CategoryProductsPage = () => {
  const location = useLocation();
  const { products, categoryTitle } = location.state;
  const [activeFilters, setActiveFilters] = useState({});

  const [isGridView, setIsGridView] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visibleProducts, setVisibleProducts] = useState(10); // Initial visible products count
  const cart =
    useSelector((state) => state.fetchCart?.cartInfo?.cartItem) || [];
  const subCategory = useSelector((state) => state.category?.subCategoryList);

  const [subcategoryIds, setSubCategoryIds] = useState([]);
  const customSort = useSelector((state) => state.fetchUser?.user?.customSort);
  const dispatch = useDispatch();
  const [totalProductLength, setTotalProductLength] = useState(0);
  const [categoryIds, setCategoryIds] = useState([]);
  const [cartLength, setCartLength] = useState(0);
  const [showMenu, setShowMenu] = useState(false);
  const userid = useSelector((state) => state.fetchUser?.user?.id);
  const [filterDataLoaded, setFilterDataLoaded] = useState(false);
  const [filterableProducts, setFilterableProducts] = useState([]);
  const [isFilterFullScreen, setFilterFullScreen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);


  const handleOpenDrawer = (product) => {
    setSelectedProduct(product);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedProduct(null);
  };

  const toggleGridView = () => {
    setIsGridView((prev) => !prev);
  };

  const updateCartLength = () => {
    return cart.filter((item) => item.storeid === userid).length;
  };

  const fetchProductList = async () => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}user/filter-seller-products/${userid}`,
        { subcategoryIds: subcategoryIds, customSort: customSort }
      );
      // const data = await response.json();
      if (response) {
        dispatch(getList(response?.data?.products));

        setTotalProductLength(response?.data?.products?.length);
      }
    } catch (error) {
      console.error("Error fetching Products:", error);
    }
  };

  function handleFilter() {
    fetchProductList();
  }

  function handleSubCategoryIdAdd(e, id) {
    if (e.target.checked === true) {
      setSubCategoryIds([...subcategoryIds, id]);
    } else if (e.target.checked === false) {
      const newSubCatIds = subcategoryIds?.filter((item) => item !== id);
      setSubCategoryIds([...newSubCatIds]);
    }
  }

  const openFilterWithData = () => {
    if (filterDataLoaded && filterableProducts.length > 0) {
      setFilterFullScreen(true);
    } else if (!filterDataLoaded && userid) {
      // If filter data isn't loaded yet but we have userid, show loading while we fetch it
      setIsLoading(true);
      const loadFilterData = async () => {
        try {
          const res = await axios.post(`${apiBaseUrl}user/filter-seller-products-by-category/${userid}`);
          if (res.data.success) {
            const enrichedProducts = res.data.products.map(p => ({
              ...p,
              price: p.price || 0,
              additionalInfo: {
                variantGroups: p.additionalInfo?.variantGroups || [],
                attributeGroups: p.additionalInfo?.attributeGroups || []
              }
            }));
            setFilterableProducts(enrichedProducts);
            setFilterDataLoaded(true);
            setFilterFullScreen(true);
          }
        } catch (err) {
          console.error("Failed to fetch filter data", err);
        } finally {
          setIsLoading(false);
        }
      };
      loadFilterData();
    }
  };

  const handleFilterApply = ({ filteredProducts, filters }) => {
    setFilteredProducts(filteredProducts);
    setActiveFilters(filters);
    setIsFilterApplied(true);
    setFilterFullScreen(false);
    setVisibleProducts(10);
  };

  useEffect(() => {
    if (categoryIds.length === 0) {
      setSubCategoryIds([]);
    }
  }, [categoryIds]);

  return (
    <>
      <HeaderSlider />
      <HeaderMainNavigation />
      <HeaderSection showMenu={showMenu} setShowMenu={setShowMenu} />
      <div className="view-more-container">
        <div className="container">
        {loading ? (
          <Loader />
        ) : (
          <>
            {products.length > 0 ? (
              <>
                <div className="collection-title">
                  <h4>{categoryTitle}</h4>
                  <BreadCrums title={categoryTitle} />
                </div>
                <div className="header-section">
                  <h5 className="fontclass">{products.length} products found</h5>
                  <div className="icons">
                    <button
                      onClick={toggleGridView}
                      className="icon-button primary-font-color row-column-item-btn"
                    >
                      {isGridView ? <CiGrid2H /> : <BsGrid />}
                    </button>
                    <span>|</span>
                    <button
                      className="icon-button primary-font-color filter-btn"
                      onClick={openFilterWithData}
                    >
                      {/* <img src="/Images/Icons/filter.png" alt="filter" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-controls="filter"/> */}
                      <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6562 0.5C13.2422 0.5 13.75 1.00781 13.75 1.59375C13.75 1.86719 13.6328 2.10156 13.4766 2.29688L9.375 6.98438V14.5625C9.375 15.1094 8.94531 15.5 8.39844 15.5C8.20312 15.5 8.00781 15.4609 7.8125 15.3438L4.84375 13.0781C4.53125 12.8438 4.375 12.4922 4.375 12.0625V6.98438L0.234375 2.29688C0.078125 2.10156 0 1.86719 0 1.59375C0 1.00781 0.46875 0.5 1.05469 0.5H12.6562ZM5.625 6.75V12.0625L8.125 13.9766V6.75C8.125 6.63281 8.16406 6.47656 8.24219 6.35938L12.2656 1.75H1.44531L5.46875 6.35938C5.54688 6.47656 5.58594 6.63281 5.58594 6.75H5.625ZM19.375 13.625C19.6875 13.625 20 13.9375 20 14.25C20 14.6016 19.6875 14.875 19.375 14.875H13.125C12.7734 14.875 12.5 14.6016 12.5 14.25C12.5 13.9375 12.7734 13.625 13.125 13.625H19.375ZM12.5 8C12.5 7.6875 12.7734 7.375 13.125 7.375H19.375C19.6875 7.375 20 7.6875 20 8C20 8.35156 19.6875 8.625 19.375 8.625H13.125C12.7734 8.625 12.5 8.35156 12.5 8ZM19.375 1.125C19.6875 1.125 20 1.4375 20 1.75C20 2.10156 19.6875 2.375 19.375 2.375H15.625C15.2734 2.375 15 2.10156 15 1.75C15 1.4375 15.2734 1.125 15.625 1.125H19.375Z" fill="currentcolor"/></svg>
                    </button>
                  </div>
                </div>
                <div
                  className="d-flex justify-content-between ProductItemContainer"
                  style={{ paddingBottom: "62px" }}
                >
                  {isGridView ? (
                    <ProductsMapList
                      productList={products}
                      handleOpenDrawer={handleOpenDrawer}
                    />
                  ) : (
                    <SingleOne
                      productList={products.slice(0, visibleProducts)}
                      handleOpenDrawer={handleOpenDrawer}
                    />
                  )}
                </div>
                <CommonDrawer
                  isOpen={isDrawerOpen}
                  onClose={handleCloseDrawer}
                  product={selectedProduct}
                />
              </>
            ) : (
              <h5 className="text-center d-block w-100 mt-5">
                No products available in this category.
              </h5>
            )}
          </>
        )}
        <div>
          {updateCartLength() > 0 && (
            <ViewCartButton cartLength={updateCartLength()} />
          )}
        </div>
      </div>
      </div>
      

      {isFilterFullScreen && (
        <ProductFilter
          products={filterableProducts}
          initialFilters={activeFilters}
          onApply={handleFilterApply}
          onClose={() => setFilterFullScreen(false)}
        />
      )}
    </>
  );
};

export default CategoryProductsPage;
